import React from 'react';

import { IconRemove } from '../../atoms/IconRemove';
import { Container, Text } from './styles';

interface InfoPassword {
  name: string;
}

export const InfoPasswordError = ({ name }: InfoPassword): JSX.Element => {
  return (
    <Container>
      <IconRemove />
      <Text> {name} </Text>
    </Container>
  );
};
